import { useState, useEffect, useMemo } from "react";
import { useForm } from "react-hook-form";
import TextField from "../../../ui/TextField";
import Summary from "../../../ui/Summary";
import SearchCondition from "../../../features/SearchCondition";
import Button from "../../../ui/Button";
import RadioGroup from "../../../ui/RadioGroup";
import CheckboxGroup from "../../../ui/CheckboxGroup";
import styles from "../../../layout/admin/Main.module.scss";
import { AUTH_SHIBUYA } from "../../../../utils/config";
import { getCodeMasterList } from "../../../../services/apiCodeMaster";
import { validateMaxlength } from "../../../../utils/validate";

const CourseApplicantSearchFrom = ({
  setSearchCondition,
  authority,
  resetUpdateData,
  period,
}) => {
  // 受講状況ラジオボタン
  const [attendanceElements, setAttendanceElements] = useState([]);

  // 初期値：開催日過ぎていなければ未受講、過ぎていれば受講済み
  const attendanceStatusDef = useMemo(() => {
    // periodがundefinedまたは無効な場合は未受講(1)をデフォルトとする
    if (!period) {
      return 1;
    }

    let d = new Date();
    let periodDate = new Date(period);

    // periodDateが無効な日付の場合
    if (isNaN(periodDate.getTime())) {
      return 1;
    }

    const statusNum = periodDate < d ? 3 : 1;

    // attendanceElementsから該当する値を取得（型を合わせる）
    if (attendanceElements.length > 0) {
      const element = attendanceElements.find(
        (el) => Number(el.value) === statusNum
      );
      return element ? element.value : statusNum;
    }
    return statusNum;
  }, [period, attendanceElements]);

  //ラジオボタン選択値
  const [selectedAttendanceStatus, setSelectedAttendanceStatus] =
    useState(null);
  // 当選状況チェックボックス
  const [lotteryStatusElements, setLotteryStatusElements] = useState([]);

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm();

  const resetCondition = () => {
    setValue("login_id", "");
    setValue("name", "");
    setValue("name_kana", "");
    setValue("street_name1", "");
    setValue("street_name2", "");
    setValue("attendance_status", attendanceStatusDef);
    setValue("lottery_status_1", false);
    setValue("lottery_status_2", false);
    setValue("lottery_status_3", false);
    setValue("lottery_status_4", false);
    setSelectedAttendanceStatus(attendanceStatusDef);
  };

  const onSubmit = (data) => {
    resetUpdateData();
    setSearchCondition(data);
  };

  useEffect(() => {
    (async function () {
      // 抽選ステータス
      const ltData = await getCodeMasterList({ code: "CD003" });
      // 受講ステータス
      const AtData = await getCodeMasterList({ code: "CD004" });
      if (AtData == undefined || !AtData || ltData == undefined || !ltData)
        return;
      setAttendanceElements(
        AtData.map((d) => {
          return { label: d.d_text, value: d.d_value };
        })
      );
      setLotteryStatusElements(
        ltData.map((d) => {
          return { label: d.d_text, value: d.d_value };
        })
      );
      setValue("lottery_status_1", false);
      setValue("lottery_status_2", false);
      setValue("lottery_status_3", false);
      setValue("lottery_status_4", false);
    })();
  }, [setValue]);

  // periodが変更されたときに受講状況を更新
  useEffect(() => {
    setValue("attendance_status", attendanceStatusDef);
    setSelectedAttendanceStatus(attendanceStatusDef);
  }, [attendanceStatusDef, setValue]);

  return (
    <div>
      <details open>
        <Summary />
        <form onSubmit={handleSubmit(onSubmit)}>
          <SearchCondition title="申込者を絞り込む">
            <table>
              <tr>
                <TextField
                  register={register}
                  validation={{
                    ...validateMaxlength(8),
                  }}
                  name="login_id"
                  errors={errors}
                  label="学生番号(8桁)"
                  placeholder="学生番号(8桁)"
                ></TextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{
                    ...validateMaxlength(100),
                  }}
                  name="name"
                  errors={errors}
                  label="氏名"
                  placeholder="氏名"
                ></TextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{
                    ...validateMaxlength(100),
                  }}
                  name="name_kana"
                  errors={errors}
                  label="フリガナ"
                  placeholder="フリガナ"
                ></TextField>
              </tr>
              {authority == AUTH_SHIBUYA ? (
                <tr>
                  <TextField
                    register={register}
                    validation={{
                      ...validateMaxlength(100),
                    }}
                    name="street_name1"
                    errors={errors}
                    label="町名"
                    placeholder="町名"
                  ></TextField>
                </tr>
              ) : (
                <></>
              )}
              {authority == AUTH_SHIBUYA ? (
                <tr>
                  <TextField
                    register={register}
                    validation={{
                      ...validateMaxlength(100),
                    }}
                    name="street_name2"
                    errors={errors}
                    label="丁名"
                    placeholder="丁名"
                  ></TextField>
                </tr>
              ) : (
                <></>
              )}
              <tr>
                <RadioGroup
                  errors={errors}
                  register={register}
                  label="受講状況"
                  name="attendance_status"
                  elements={attendanceElements}
                  watch={watch}
                  selectedValue={selectedAttendanceStatus}
                  setSelectedValue={setSelectedAttendanceStatus}
                />
              </tr>
              <tr>
                <CheckboxGroup
                  errors={errors}
                  register={register}
                  label="当選状況"
                  name="lottery_status"
                  elements={lotteryStatusElements}
                />
              </tr>
            </table>

            {errors.exampleRequired && <span>This field is required</span>}
          </SearchCondition>
          <div className={styles.buttonbox}>
            <Button type="submit" styleType="search">
              検索
            </Button>
            <Button
              type="button"
              styleType="back"
              onClick={() => resetCondition()}
            >
              条件クリア
            </Button>
          </div>
        </form>
      </details>
    </div>
  );
};

export default CourseApplicantSearchFrom;
